/**
 * @ngInject
 */

function menu() {

	function MenuController($scope, $element, $attrs, $location, $auth, $mdDialog, userStore, flux, actions, Tracking){
		// console.log("menuController");

		var ctrl = this;
		ctrl.isAuthenticated = false; 
		$scope.$listenTo(userStore, ['user'], authCallback);

		function toggleNav() {
			$element[0].querySelector('.nav').classList.toggle('open');
		}

		function authCallback(response){
			// console.log("authCallback", response);

			ctrl.isAuthenticated = $auth.isAuthenticated();
			// console.log("isAuthenticated", ctrl.isAuthenticated);

			if (!$scope.$$phase) $scope.$apply();
		}

		this.login = function login(ev) {
			Tracking.trackEvent("menu", "log ind", "");

		    $mdDialog.show({
				controller: DialogCtrl,
				controllerAs: '$ctrl',
				templateUrl: './angular/views/dialog.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: false,
				locals: {
				    state: 'login',
				    successBtnState: 'frontpage'
				}
		    });
			toggleNav();
		};

	    this.logout = function logout()
	    {
	    	Tracking.trackEvent("menu", "log ud", "");
	    	flux.dispatch('LOGOUT_USER', {});
	    	// console.log("Logout");
	    	toggleNav();
	    	window.location.href = "/";
	    };
	}

	function link (scope, elem, attrs) {
	    var btn = elem[0].querySelector('.btn-menu');
	    var close = elem[0].querySelector('.btn-close');
	    var backBtn = elem[0].querySelector('.btn-back');

	    btn.addEventListener('click', onMenuClick);
	    close.addEventListener('click', onMenuClick);
	    backBtn.addEventListener('click', onBackClick);

	    function onMenuClick(){
	    	elem[0].querySelector('.nav').classList.toggle('open');
	    	if(elem[0].querySelector('.nav').classList.contains('open')) {
	    		document.body.style.overflow = "hidden";
	    		if(Modernizr.touchevents) {
	    			document.ontouchmove = function (e) {
	    			  e.preventDefault();
	    			};
	    		}
	    	} else {
	    		document.body.style.overflow = "auto";
	    		if(Modernizr.touchevents) {
	    			document.ontouchmove = function (e) {
	    			  return true;
	    			};
	    		}
	    	}
	    }

	    function onBackClick(){
	    	if(window.location.hash === '#!/') {
	    		window.location.href = '/';
	    	} else {
	    		window.history.back();
	    	}
	    }

	}

	return {
		controller: MenuController,
		controllerAs: 'menuCtrl',
		bindToController: true,
		restrict: "A",
		link : link
	};
}